import { ChangeToPrescriptionForYearLink } from '../../prescription/treatmentDaysCount/ChangeToPrescriptionForYearLink';
import { TreatmentDaysCountExceededMessage } from '../../prescription/treatmentDaysCount/TreatmentDaysCountExceededMessage';
import { AdditionalRequirement } from '../../prescription/additionalRequirements/additionalRequirements.types';
import { DraftPrescriptionsFormController } from '../DraftPrescriptionsForm.types';

import { DraftStandardPrescriptionFieldName } from './DraftStandardPrescriptionField.types';

type DraftStandardPrescriptionTreatmentDaysExceededSlotProps = Pick<DraftPrescriptionsFormController, 'setValue'> & {
   readonly name: DraftStandardPrescriptionFieldName;
   readonly maxValue: number;
   readonly changeToPrescriptionForYearAvailable: boolean;
   readonly additionalRequirements: AdditionalRequirement[] | null | undefined;
};

export const DraftStandardPrescriptionTreatmentDaysExceededSlot = (
   props: DraftStandardPrescriptionTreatmentDaysExceededSlotProps
): JSX.Element => {
   return (
      <TreatmentDaysCountExceededMessage
         maxValue={props.maxValue}
         changeToPrescriptionForYear={
            props.changeToPrescriptionForYearAvailable ? (
               <ChangeToPrescriptionForYearLink
                  setValue={props.setValue}
                  name={props.name}
                  additionalRequirements={props.additionalRequirements}
               />
            ) : undefined
         }
      />
   );
};
